import { Injectable } from '@angular/core';

@Injectable()
export class AppSettings {
  static NonBearerUrl = '';
  public AzureAccount = 'csgbca3ef5a854cx46a1x82a';
  public defaultImageSize = 15728640;
  public defaultVideoSize = 262144000;
}
